import { HttpClient } from "@angular/common/http";
import {
  Component,
  Injector,
  Input,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { filter, map, tap } from "rxjs/operators";
import { TableAbstractComponent } from "src/app/common-page-components/classes/table-abstract-component";
import { IHeaderConfig } from "src/app/common-page-components/headers-component/headers-component.component";
import {
  AthleteWCupPageStore,
  IWCupAthleteDetail,
} from "src/app/common-page-components/stores/entities-store/world-cup-athlete.store";
import { FilterWCupRankingService } from "src/app/world-ranking-statistics/wcup-ranking/services/filter-wcup-ranking.service";
import { AthleteWcupRankingFiltersFinalsService } from "../../services/athlete-wcup-ranking-filters-finals.service";
import { WCupInsightsDto } from "src/app/athlete/athlete-wcup-ranking/components/bootstrap-athlete-wcup-ranking/bootstrap-athlete-wcup-ranking.component";

@Component({
  selector: "app-athlete-finals-table-wcup-ranking-table",
  templateUrl: "./athlete-finals-table-wcup-ranking-table.component.html",
  styleUrls: ["./athlete-finals-table-wcup-ranking-table.component.scss"],
})
export class AthleteFinalsTableWcupRankingTableComponent extends TableAbstractComponent {
  /**
   * The header to be presented before table.
   *
   * @type {string}
   * @memberof AthleteFinalsTableWcupRankingTableComponent
   */
  @Input() wCupName: string;

  /**
   * The process detail to be show as table rows.
   *
   * @type {Array<IWCupAthleteDetail>}
   * @memberof AthleteFinalsTableWcupRankingTableComponent
   */
  @Input() processDataDetail: Array<IWCupAthleteDetail> = [];


  /**
   * The pagination start index.
   *
   * @memberof AthleteFinalsTableWcupRankingTableComponent
   */
  pagination_start = 0;

  /**
   * The pagination end index.
   *
   * @memberof AthleteFinalsTableWcupRankingTableComponent
   */
  pagination_end = 10;

  /**
   * The insights that appears on the left of the table.
   *
   * @type {{ appearances: number; podiums: number; wins: number }}
   * @memberof AthleteFinalsTableWcupRankingTableComponent
   */
  @Input() insights: WCupInsightsDto = new WCupInsightsDto();

  /**
   * The headers of the table.
   *
   * @type {Array<IHeaderConfig>}
   * @memberof AthleteFinalsTableWcupRankingTableComponent
   */
  headers: Array<IHeaderConfig> = [
    { name: "Year", isSortable: true, sortProperty: "YEAR" }, // Year
    { name: "Location", isSortable: true, sortProperty: "LOCATION" }, // Place
    { name: "Event", isSortable: true, sortProperty: "EVENT" }, // Event
    { name: "Result", isSortable: true, sortProperty: "RESULT" }, // Result
  ];

  constructor(
    injector: Injector,
    public filter_service_copy: AthleteWcupRankingFiltersFinalsService
  ) {
    super(
      injector,
      filter_service_copy,
      new AthleteWCupPageStore(injector.get(HttpClient), injector)
    );
    this.filter_service
  }
  /**
   * {@inheritdoc}
   *
   * @memberof AthleteGeneralTableWcupRankingTableComponent
   */
  ngOnInit() {
    super.ngOnInit();
    this.subscriptions.push(
      this.filter_service.orderValue
        .pipe(
          filter((value) => value.sortingType == null),
          tap((a) => this.changeSort("YEAR"))
        )
        .subscribe()
    );
    this.subscriptions.push(
      this.filter_service.orderValue
        .pipe(
          tap((a) => {
            const isAsc = a.asc ? 1 : -1;
            switch (a.sortingType as string) {
              case "YEAR":
                this.processDataDetail.sort((f, s) => {
                  return f.Year > s.Year ? -isAsc : isAsc;
                });
                break;
              case "LOCATION":
                this.processDataDetail.sort((f, s) => {
                  return f.Place > s.Place ? -isAsc : isAsc;
                });
                break;
              case "EVENT":
                this.processDataDetail.sort((f, s) => {
                  return (f as any).Event > (s as any).Event ? -isAsc : isAsc;
                });
                break;
              case "RESULT":
                this.processDataDetail.sort((f, s) => {
                  return (f as any).Results["Rnk"] > (s as any).Results["Rnk"]
                    ? -isAsc
                    : isAsc;
                });
                break;
            }
          })
        )
        .subscribe()
    );
  }

  /**
   * {@inheritdoc}
   *
   * @memberof AthleteFinalsTableWcupRankingTableComponent
   */
  loadMore(): void {
    this.pagination_end = this.pagination_end + 10;
  }

  /**
   * {@inheritdoc}
   *
   * @memberof AthleteFinalsTableWcupRankingTableComponent
   */
  areMoreData(): boolean {
    return this.processDataDetail.length - 1 > this.pagination_end;
  }

  /**
   * Gets the data with slice for computed pagination.
   *
   * @readonly
   * @memberof AthleteFinalsTableWcupRankingTableComponent
   */
  get dataWithPagination() {
    return this.processDataDetail.slice(0, this.pagination_end);
  }

  ngAfterViewInit(): void { }

  /**
   * {@inheritdoc}
   *
   * @memberof AthleteGeneralTableWcupRankingTableComponent
   */
  ngOnChanges(changes: SimpleChanges) {
    if ("processDataDetail" in changes) {
      // Reset pagination on new data.
      this.pagination_end = 10;
    }
  }

  get eventTypeData() {
    return this.filter_service_copy.eventTypeCombo.comboData.pipe(map(a => {
      return a.Name
    }))
  }
}
